/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/api/PropertiesProviderAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../app/nls/StringResources'
], function(_, PropertiesProviderAPI, APIFactory, stringResources) {
	class ShapePropertiesProvider {

		constructor({ content, dashboardAPI, options }) {
			this.content = content;
			this.dashboardApi = dashboardAPI;
			this._api = APIFactory.createAPI(this, [PropertiesProviderAPI]);
			this._shapeTypes = options.shapeTypes;
			// register self as a properties provider contributing shape widget properties
			this.content.getFeature('Properties').registerProvider(this.getAPI());
			this.getWidgetModel().whitelistAttrs = this.getWidgetModel().whitelistAttrs.concat(['lineWidth', 'dashStyle', 'lineCap']);
		}

		getAPI() {
			return this._api;
		}

		destroy() {
			this.dashboardApi = null;
		}

		getPropertyLayoutList(){
			if (this._shapeTypes.indexOf(this.getWidgetModel().name) !== -1) {
				return [{ id: 'appearance',
					label: stringResources.get('sectionName_appearance'),
					position: 3,
					type: 'Section' }];
			} else {
				return [];
			}
		}

		onChange(e, v) {
			this.content.setPropertyValue(e, v);
		}

		_getOptions(minVal, maxVal) {
			const options = [];
			for(let i = minVal; i <= maxVal; i++) {
				options.push({
					'label': String(i),
					'value': String(i)
				});
			}
			return options;
		}

		getPropertyList() {
			if (this._shapeTypes.indexOf(this.getWidgetModel().name) !== -1) {
				return [
					{
						'editor': {
							'sectionId': 'general.appearance',
							uiControl: {
								type: 'DropDown',
								label: stringResources.get('propStrokeWidth'),
								defaultValue: '3',
								onChange: this.onChange.bind(this),
								options: this._getOptions(1, 20)
							}
						},
						'id': 'lineWidth',
						setPropertyValue: (propertyValue) => {
							this.setPropertyValue('lineWidth', propertyValue);
						},
						getPropertyValue: () => {
							return this.getWidgetModel().get('lineWidth');
						},
						supportsUndoRedo: true
					},
					{
						'editor': {
							'sectionId': 'general.appearance',
							uiControl: {
								type: 'DropDown',
								label: stringResources.get('propStrokeDashArray'),
								defaultValue: null,
								options: [{
									'label':  stringResources.get('propStrokeSolidline'),
									'value': null
								}, {
									'label': '. . . .',
									'value': '5, 5'
								}, {
									'label': '- - - -',
									'value': '10, 10'
								}, {
									'label': '-- . . --',
									'value': '20,10,5,5,5,10'
								}
								],
								onChange: this.onChange.bind(this)
							}
						},
						'id': 'dashStyle',
						setPropertyValue: (propertyValue) => {
							this.setPropertyValue('dashStyle', propertyValue);
						},
						getPropertyValue: () => {
							return this.getWidgetModel().get('dashStyle');
						},
						supportsUndoRedo: true
					},
					{
						'editor': {
							'sectionId': 'general.appearance',
							uiControl: {
								type: 'DropDown',
								label: stringResources.get('propStrokeLineCap'),
								defaultValue: null,
								options: [{
									'label': stringResources.get('propStrokeLineCapButt'),
									'value': null
								}, {
									'label': stringResources.get('propStrokeLineCapRound'),
									'value': 'round'
								}, {
									'label': stringResources.get('propStrokeLineCapSquare'),
									'value': 'square'
								}],
								onChange: this.onChange.bind(this)
							}
						},
						'id': 'lineCap',
						setPropertyValue: (propertyValue) => {
							this.setPropertyValue('lineCap', propertyValue);
						},
						getPropertyValue: () => {
							return this.getWidgetModel().get('lineCap');
						},
						supportsUndoRedo: true
					}
				];
			} else {
				return [];
			}
		}

		reset() { }

		setPropertyValue(propertyName, propertyValue) {
			const propertyPayload = {};
			propertyPayload[propertyName] = propertyValue;
			this.set(propertyPayload, {
				payloadData: { skipUndoRedo: true }
			});
		}

		getWidgetModel() {
			return this.content.getFeature('Models.internal').getWidgetModel();
		}

		set(attributes, options) {
			if (attributes) {
				options = options || {};
				options = _.defaults(options, {
					sender: this.id
				});
				this.getWidgetModel().set(attributes, options);
			}
		}
	}

	return ShapePropertiesProvider;

});